import { MIMETYPE_GEOPACKAGE } from '@disy/lib/media-type';

import { AbstractDataViewExportAction } from 'cadenza/actions/table/abstract-data-view-export-action';
import type { ExportActionContext } from 'cadenza/workbook/actions/export-actions';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';
import { openExportGeopackageDialog } from 'cadenza/workbook/workbook-panel/settings/actions/open-export-geopackage-dialog';

import i18n from './export-to-geopackage-action.properties';

export class ExportGeopackageAction extends AbstractDataViewExportAction {
  readonly #dataViewId;
  readonly #actionContext;

  constructor(dataViewId: DataViewId, actionContext: ExportActionContext) {
    super(dataViewId, actionContext, MIMETYPE_GEOPACKAGE, {
      label: i18n('action.label'),
      dialogTitle: i18n('dialog.title'),
    });
    this.#dataViewId = dataViewId;
    this.#actionContext = actionContext;
  }

  override execute() {
    return openExportGeopackageDialog(this.#dataViewId, this.#actionContext);
  }

  override get enabledSync() {
    return true;
  }
}
